// Base service name
export const SERVICE_NAME = "LOCAL_STORAGE_SERVICE";

export const STORAGE_KEY = {
	DEMO_ITEM: "demo-item",
};
